// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable sonarjs/cognitive-complexity */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fromJS, List } from 'immutable';
import { setDefaultSuggestedStores } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import {
  internalCampaignProductAnalyticsList,
  fireEnhancedEcomm,
  internalPromotionFormattedProducts,
  getViewportInfo,
  isClient,
} from '@tcp/core/src/utils';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import {
  getAPIConfigForAdobe,
  getSessionDataForAdobe,
  getUserState,
} from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import names from '../../../../../constants/eventsName.constants';
import {
  getNearByStore,
  getModuleXContent,
  setCurrentStoreInfo,
  getCurrentStoreInfo,
  fetchProductsRequest,
  resetStoreSpecialProducts,
} from './StoreDetail.actions';
import StoreDetailSkelton from '../skelton/StoreDetailSkelton.view';
import { setFavoriteStoreActn } from '../../StoreLanding/container/StoreLanding.actions';
import StoreDetail from './views/StoreDetail';
import { routeToStoreDetails, routerPush } from '../../../../../utils';
import {
  getCurrentStore,
  formatCurrentStoreToObject,
  getNearByStores,
  isFavoriteStore,
  getReferredContentList,
  getRichTextContent,
  getSeoData,
  getStoreDetailLoadingState,
  getNearByStoresLoading,
  getStoreSpecialProducts,
  getStoreSpecialProductsLoading,
} from './StoreDetail.selectors';
import googleMapConstants from '../../../../../constants/googleMap.constants';
import { trackPageView, setClickAnalyticsData } from '../../../../../analytics/actions';
import {
  getMapboxSwitch,
  storeHoursWebEnabled,
  storeHoursAppEnabled,
  getSpecialHoursNumberOfDaysToConsider,
  storeDetailsRedesignEnabled,
  getBossMultipleStoreEnabled,
  getIsStsCtaEnabled,
  getIsShopThisStoreEnabled,
  getIsBuyMorePromoEnabled,
  getTileRedesignAB,
  getIsUpdatedPromotionsDisplayEnabled,
  showStoreSpecialProductsOnStoreDetails,
  getShowBopisTileBasedOnStoreSpecials,
  getDefaultStoreMessage,
  getIsViewMapEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import { setDefaultStore } from '../../../account/User/container/User.actions';
import { StoreDetailWrapper } from './styles/StoreDetail.style';
import constants from './StoreDetail.constants';
import { openQuickViewWithValues } from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import {
  getPromotionsData,
  getServerTimeFromState,
  getStoreDiscount,
  getStoreSpecialDiscountValue,
} from '../../../../common/organisms/Promotions/container/Promotions.selectors';
import ViewMapModal from './views/ViewMapModal';

export class StoreDetailContainer extends PureComponent {
  static routesBack(e) {
    e.preventDefault();
    if (window.history.length > 2) window.history.back();
    else {
      routerPush('/', '/home');
    }
  }

  constructor(props) {
    super(props);

    // Initialize state
    this.state = {
      isViewMapModalOpen: false, // New state variable
      viewMapImageUrl: '',
      // Add other state variables here if needed
    };
  }

  componentDidMount() {
    const { getModuleX, referredContentList, trackStoreDetailPageView, User, APIConfig, session } =
      this.props;
    const pageName = 'companyinfo:companyinfo';
    const products = internalCampaignProductAnalyticsList();

    const pageData = {
      pageName: 'store detail',
      pageSection: 'store locator',
      pageSubSection: '',
      pageSubSection2: '',
      pageType: 'store page',
    };

    trackStoreDetailPageView({
      customEvents: ['event80', 'event96'],
      pageName,
      pageShortName: pageName,
      pageType: 'companyinfo',
      pageSection: 'companyinfo',
      pageSubSection: 'companyinfo',
      internalCampaignIdList: internalCampaignProductAnalyticsList(),
    });
    if (products) {
      fireEnhancedEcomm({
        eventName: 'internalcampaignimpression',
        productsObj: internalPromotionFormattedProducts(products),
        eventType: 'promoView',
        pageName,
        currCode: 'USD',
      });
    } else {
      pushEventToAdobeAnalytics('page_view', { pageData, User, APIConfig });
    }

    this.loadCurrentStoreInitialInfo();
    getModuleX(referredContentList);
    pushEventToAdobeAnalytics('page_view', { pageData, User, APIConfig, session });
  }

  componentDidUpdate(prevProps) {
    const { currentStoreInfo, formatStore, resetCaraosalProducts } = this.props;
    const prevStore = formatStore(prevProps.currentStoreInfo);
    const newStore = formatStore(currentStoreInfo);
    if (
      (prevStore.basicInfo !== undefined && prevStore.basicInfo.id) !==
      (newStore.basicInfo !== undefined && newStore.basicInfo.id)
    ) {
      this.loadCurrentStoreInitialInfo();
      pushEventToAdobeAnalytics('store_page_view', newStore?.basicInfo);
      resetCaraosalProducts([]);
    }
  }

  componentWillUnmount() {
    const { resetCurrentStoreInfo } = this.props;

    resetCurrentStoreInfo();
  }

  openStoreDetails = (event, store) => {
    event.preventDefault();
    setTimeout(() => {
      const { routerHandler } = routeToStoreDetails(store);
      const { resetCurrentStoreInfo } = this.props;
      resetCurrentStoreInfo();
      routerHandler();
    }, 0);
  };

  shouldRenderDetails = (store) => store && store.basicInfo && store.basicInfo.id;

  openStoreDirections(store) {
    const {
      basicInfo: { address },
    } = store;
    const { addressLine1, city, state, zipCode } = address;
    window.open(
      `${googleMapConstants.OPEN_STORE_DIR_WEB}${addressLine1},%20${city},%20${state},%20${zipCode}`,
      '_blank',
      'noopener'
    );
  }

  // Method to toggle modal state
  toggleViewMapModal = () => {
    this.setState((prevState) => ({
      isViewMapModalOpen: !prevState.isViewMapModalOpen,
    }));
  };

  openViewMapModal = (locationImageUrl) => {
    // Logic to handle opening the map
    this.toggleViewMapModal(); // Example of using the state variable
    this.setState(() => ({
      viewMapImageUrl: locationImageUrl,
    }));
  };

  loadCurrentStoreInitialInfo() {
    const { loadNearByStoreInfo, currentStoreInfo, formatStore } = this.props;
    const store = formatStore(currentStoreInfo);
    if (store.basicInfo && Object.keys(store.basicInfo).length > 0) {
      const { basicInfo } = store;
      const { coordinates } = basicInfo;

      if (coordinates?.lat && coordinates?.long) {
        const locationstorePayload = {
          coordinates: {
            lng: coordinates.long,
            lat: coordinates.lat,
          },
          maxItems: constants.OTHER_STORES_COUNT,
          fromNearByStore: true,
        };
        loadNearByStoreInfo(locationstorePayload);
      }
    }
  }

  updateStoreLocation = (store, currentStoreDataInNearByStores) => {
    if (
      Array.isArray(currentStoreDataInNearByStores) &&
      currentStoreDataInNearByStores.length > 0 &&
      currentStoreDataInNearByStores[0]?.basicInfo?.storeLocation
    ) {
      return currentStoreDataInNearByStores[0].basicInfo.storeLocation;
    }
    return '';
  };

  // eslint-disable-next-line complexity
  render() {
    const {
      currentStoreInfo,
      formatStore,
      nearByStores,
      isFavorite,
      setFavStore,
      getRichContent,
      setResStatusNotFound,
      seoData,
      mapboxSwitch,
      isStoreHoursWebEnabled,
      isStoreHoursAppEnabled,
      specialHoursNumberOfDaysCount,
      isStoreDetailsRedesignEnabled,
      setDefaultSuggestedStoresAction,
      isBossMultiStoreEnabled,
      suggestedStoreList,
      fetchCurrentStore,
      navigation,
      isShopThisStoreEnabled,
      isStsCtaEnabled,
      updateStore,
      isNearByStoresLoading,
      onQuickViewOpenClick,
      promotionsData,
      serverTime,
      isBuyMorePromoEnabled,
      isTileRedesignAB,
      isUpdatedPromotionsDisplayEnabled,
      isStoreSpecialProductsOnStoreDetails,
      isStoreSpecialsPriceOn,
      storeSpecialDiscount,
      fetchStoreSpecialProducts,
      storeSpecialProducts,
      storeDiscount,
      defaultStoreMessage,
      isStoreSpecialProductsLoading,
      isViewMapEnabled,
    } = this.props;
    const { dataLoading } = this.props;
    const { isDesktop } = (isClient() && getViewportInfo()) || {};
    const store = formatStore(currentStoreInfo);
    let nearByStoresArray = nearByStores;
    if (List.isList(nearByStoresArray)) {
      nearByStoresArray = JSON.parse(JSON.stringify(nearByStoresArray));
    }
    let currentStoreHolidayHours =
      nearByStoresArray && nearByStoresArray.length > 0
        ? nearByStoresArray.filter(
            (nStore) =>
              nStore.basicInfo && store.basicInfo && nStore.basicInfo.id === store.basicInfo.id
          )
        : null;
    currentStoreHolidayHours = currentStoreHolidayHours?.[0]?.hours?.holidayHours;
    const currentStoreDataInNearByStores =
      nearByStoresArray && nearByStoresArray.length > 0
        ? nearByStoresArray.filter(
            (nStore) =>
              nStore.basicInfo && store.basicInfo && nStore.basicInfo.id === store.basicInfo.id
          )
        : [];
    if (
      currentStoreDataInNearByStores.length > 0 &&
      currentStoreDataInNearByStores[0]?.storeMessage
    ) {
      store.storeMessage = currentStoreDataInNearByStores[0].storeMessage;
    }
    const otherStores =
      nearByStoresArray && nearByStoresArray.length > 0
        ? nearByStoresArray.filter(
            (nStore) =>
              nStore.basicInfo && store.basicInfo && nStore.basicInfo.id !== store.basicInfo.id
          )
        : [];
    const { isViewMapModalOpen, viewMapImageUrl } = this.state;
    if (store.basicInfo) {
      store.basicInfo.storeLocation = this.updateStoreLocation(
        store,
        currentStoreDataInNearByStores
      );
    }

    const renderStoreDetail = (mob, dsk, old) => {
      return (
        <>
          <StoreDetail
            className="storedetailinfo"
            store={store}
            otherStores={otherStores}
            openStoreDetails={this.openStoreDetails}
            openStoreDirections={() => this.openStoreDirections(store)}
            routesBack={this.constructor.routesBack}
            setFavoriteStore={setFavStore}
            isFavorite={isFavorite}
            fetchRichContent={getRichContent}
            isDataLoading={dataLoading}
            seoData={seoData}
            mapboxSwitch={mapboxSwitch}
            isStoreHoursWebEnabled={isStoreHoursWebEnabled}
            isStoreHoursAppEnabled={isStoreHoursAppEnabled}
            specialHoursNumberOfDaysCount={specialHoursNumberOfDaysCount}
            currentStoreHolidayHours={currentStoreHolidayHours}
            isStoreDetailsDesktopRedesignEnabled={dsk}
            isStoreDetailsRedesignMobileEnabled={mob}
            oldDesign={old}
            isDesktop={isDesktop}
            setDefaultSuggestedStoresAction={setDefaultSuggestedStoresAction}
            isBossMultiStoreEnabled={isBossMultiStoreEnabled}
            suggestedStoreList={suggestedStoreList}
            fetchCurrentStore={fetchCurrentStore}
            navigation={navigation}
            isStsCtaEnabled={isStsCtaEnabled}
            isShopThisStoreEnabled={isShopThisStoreEnabled}
            updateStore={updateStore}
            isStoreDetailsRedesignEnabled={isStoreDetailsRedesignEnabled}
            isNearByStoresLoading={isNearByStoresLoading}
            onQuickViewOpenClick={onQuickViewOpenClick}
            promotionsData={promotionsData}
            serverTime={serverTime}
            isBuyMorePromoEnabled={isBuyMorePromoEnabled}
            isTileRedesignAB={isTileRedesignAB}
            isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
            isStoreSpecialProductsOnStoreDetails={isStoreSpecialProductsOnStoreDetails}
            isStoreSpecialsPriceOn={isStoreSpecialsPriceOn}
            storeSpecialDiscount={storeSpecialDiscount}
            fetchStoreSpecialProducts={fetchStoreSpecialProducts}
            storeSpecialProducts={storeSpecialProducts}
            storeDiscount={storeDiscount}
            defaultStoreMessage={defaultStoreMessage}
            isStoreSpecialProductsLoading={isStoreSpecialProductsLoading}
            openViewMapModal={this.openViewMapModal}
            isViewMapEnabled={isViewMapEnabled}
          />
          {isViewMapModalOpen && isViewMapEnabled && (
            <ViewMapModal
              isOpen={isViewMapModalOpen}
              onRequestClose={this.toggleViewMapModal}
              viewMapImageUrl={viewMapImageUrl}
            />
          )}
        </>
      );
    };

    if ((!store || !store.basicInfo || !store.basicInfo.id) && setResStatusNotFound) {
      setResStatusNotFound();
    }

    if (dataLoading) {
      return <StoreDetailSkelton />;
    }
    if (!isStoreDetailsRedesignEnabled) {
      return renderStoreDetail(false, false, true);
    }

    return this.shouldRenderDetails(store) ? (
      <div>
        <StoreDetailWrapper desktop>{renderStoreDetail(false, true, false)}</StoreDetailWrapper>
        <StoreDetailWrapper mobile>{renderStoreDetail(true, false, false)}</StoreDetailWrapper>
      </div>
    ) : null;
  }
}

StoreDetailContainer.getInitialProps = () => {
  return {
    pageData: {
      loadAnalyticsOnload: false,
    },
  };
};

StoreDetailContainer.propTypes = {
  currentStoreInfo: PropTypes.instanceOf(Map),
  setResStatusNotFound: PropTypes.func.isRequired,
  formatStore: PropTypes.func.isRequired,
  nearByStores: PropTypes.shape([]).isRequired,
  labels: PropTypes.shape({
    lbl_storelanding_openInterval: PropTypes.string,
    lbl_storelanding_milesAway: PropTypes.string,
    lbl_storelanding_getdirections_link: PropTypes.string,
    lbl_storelanding_favStore: PropTypes.string,
    lbl_storelanding_setfavStore: PropTypes.string,
    lbl_storelanding_atThisPlace: PropTypes.string,
    lbl_storelanding_storedetails_link: PropTypes.string,
    lbl_storedetails_getdirections_btn: PropTypes.string,
    lbl_storedetails_getdirections_text: PropTypes.string,
    lbl_storedetails_callstore_btn: PropTypes.string,
    lbl_storedetails_changestore_btn: PropTypes.string,
    lbl_storedetails_mallType: PropTypes.string,
    lbl_storedetails_entranceType: PropTypes.string,
    lbl_storedetails_locations_details_btn: PropTypes.string,
    lbl_storedetails_locations_title: PropTypes.string,
  }).isRequired,
  loadNearByStoreInfo: PropTypes.func.isRequired,
  isFavorite: PropTypes.bool.isRequired,
  setFavStore: PropTypes.func.isRequired,
  navigation: PropTypes.shape({}),
  getModuleX: PropTypes.func,
  referredContentList: PropTypes.shape([]),
  getRichContent: PropTypes.func,
  trackStoreDetailPageView: PropTypes.func,
  resetCurrentStoreInfo: PropTypes.func,
  seoData: PropTypes.shape({}),
  dataLoading: PropTypes.bool,
  mapboxSwitch: PropTypes.bool,
  isStoreHoursWebEnabled: PropTypes.bool,
  isStoreHoursAppEnabled: PropTypes.bool,
  isStoreDetailsRedesignEnabled: PropTypes.bool,
  setDefaultSuggestedStoresAction: PropTypes.func.isRequired,
  isBossMultiStoreEnabled: PropTypes.bool.isRequired,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
  session: PropTypes.shape({}),
  isStoreSpecialProductsLoading: PropTypes.bool,
};

StoreDetailContainer.defaultProps = {
  trackStoreDetailPageView: () => {},
  currentStoreInfo: fromJS({
    basicInfo: {
      id: '',
      storeName: '',
      phone: '',
      coordinates: {},
      address: {},
    },
    hours: {},
    features: {
      mallType: '',
      entranceType: '',
    },
  }),
  navigation: {},
  getModuleX: () => null,
  referredContentList: [],
  getRichContent: () => null,
  resetCurrentStoreInfo: () => {},
  seoData: {},
  dataLoading: true,
  mapboxSwitch: true,
  isStoreHoursWebEnabled: false,
  isStoreHoursAppEnabled: false,
  isStoreDetailsRedesignEnabled: false,
  User: {},
  APIConfig: {},
  session: {},
  isStoreSpecialProductsLoading: false,
};

const mapStateToProps = (state) => {
  return {
    currentStoreInfo: getCurrentStore(state),
    formatStore: (store) => formatCurrentStoreToObject(store),
    nearByStores: getNearByStores(state),
    isFavorite: isFavoriteStore(state),
    referredContentList: getReferredContentList(),
    getRichContent: (key) => getRichTextContent(state, key),
    seoData: getSeoData(state),
    dataLoading: getStoreDetailLoadingState(state),
    mapboxSwitch: getMapboxSwitch(state),
    isStoreHoursWebEnabled: storeHoursWebEnabled(state),
    isStoreHoursAppEnabled: storeHoursAppEnabled(state),
    specialHoursNumberOfDaysCount: getSpecialHoursNumberOfDaysToConsider(state),
    isStoreDetailsRedesignEnabled: storeDetailsRedesignEnabled(state),
    isBossMultiStoreEnabled: getBossMultipleStoreEnabled(state),
    suggestedStoreList: state?.StoreLocatorReducer?.get('suggestedStores'),
    isStsCtaEnabled: getIsStsCtaEnabled(state),
    isShopThisStoreEnabled: getIsShopThisStoreEnabled(state),
    isNearByStoresLoading: getNearByStoresLoading(state),
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    session: getSessionDataForAdobe(state),
    promotionsData: getPromotionsData(state),
    serverTime: getServerTimeFromState(state),
    isBuyMorePromoEnabled: getIsBuyMorePromoEnabled(state),
    isTileRedesignAB: getTileRedesignAB(state),
    isUpdatedPromotionsDisplayEnabled: getIsUpdatedPromotionsDisplayEnabled(state),
    isStoreSpecialProductsOnStoreDetails: showStoreSpecialProductsOnStoreDetails(state),
    storeSpecialDiscount: getStoreSpecialDiscountValue(state),
    isStoreSpecialsPriceOn: getShowBopisTileBasedOnStoreSpecials(state),
    storeSpecialProducts: getStoreSpecialProducts(state),
    storeDiscount: getStoreDiscount(state),
    defaultStoreMessage: getDefaultStoreMessage(state),
    isStoreSpecialProductsLoading: getStoreSpecialProductsLoading(state),
    isViewMapEnabled: getIsViewMapEnabled(state),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  loadNearByStoreInfo: (payload) => {
    dispatch(getNearByStore(payload));
  },
  setFavStore: (payload) => dispatch(setFavoriteStoreActn({ ...payload, key: 'DETAIL' })),
  setDefaultSuggestedStoresAction: (payload) => dispatch(setDefaultSuggestedStores(payload)),
  getModuleX: (payload) => {
    dispatch(getModuleXContent(payload));
  },
  resetCurrentStoreInfo: () => dispatch(setCurrentStoreInfo(null)),
  fetchCurrentStore: (payload) => dispatch(getCurrentStoreInfo(payload)),
  updateStore: (payload) => {
    dispatch(setDefaultStore(payload));
  },
  trackStoreDetailPageView: (payload) => {
    const { customEvents, ...restPayload } = payload;

    dispatch(
      setClickAnalyticsData({
        customEvents,
      })
    );

    dispatch(
      trackPageView({
        currentScreen: names.screenNames.store_details,
        pageData: {
          ...restPayload,
        },
        props: {
          initialProps: {
            pageProps: {
              pageData: {
                ...restPayload,
              },
            },
          },
        },
      })
    );

    const timer = setTimeout(() => {
      dispatch(setClickAnalyticsData({}));
      clearTimeout(timer);
    }, 600);
  },
  onQuickViewOpenClick: (payload) => {
    dispatch(openQuickViewWithValues(payload));
  },
  fetchStoreSpecialProducts: (payload) => dispatch(fetchProductsRequest(payload)),
  resetCaraosalProducts: (payload) => dispatch(resetStoreSpecialProducts(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreDetailContainer);
